import { useContext, useEffect, useState } from 'react'

import { Box, BoxProps, Indicator, Transition } from '@mantine/core'

import AirPopulation from 'components/atoms/icons/AirPopulation'
import { IconProps } from 'components/atoms/icons/types'
import { DataTrackingType } from 'interfaces/types'

import useStyles from './index.styles'
import { AirPopulationContext } from '../context'
import { ModalDetail } from '../ModalDetail'
import { SimpleChart } from '../SimpleChart'

type Props = {
  iconProps?: IconProps
  dataTracking?: DataTrackingType
} & BoxProps

const TIME_DURATION = 4000

const transition = {
  in: { opacity: 1, transform: 'translateX(0)' },
  out: { opacity: 0, transform: 'translateX(50%)' },
  transitionProperty: 'transform, opacity',
}

export const IconChart = ({ dataTracking, className, ...boxProps }: Props) => {
  const { firstLoading, size } = useContext(AirPopulationContext)
  // const [hovered, setHovered] = useState(false)
  const [startAnimate, setStartAnimate] = useState(false)
  const [toggle, setToggle] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const { classes, cx } = useStyles(undefined, {
    name: 'AirPopulation__IconChart',
  })

  useEffect(() => {
    if (firstLoading) return
    setToggle((prev) => !prev)
    setStartAnimate(true)
  }, [firstLoading])

  useEffect(() => {
    if (!startAnimate) return
    const interval = setInterval(() => {
      setToggle((prev) => !prev)
    }, TIME_DURATION)
    return () => clearInterval(interval)
  }, [startAnimate])

  // useEffect(() => {
  //   if (hovered) {
  //     setStartAnimate(false)
  //     setToggle(true)
  //   } else {
  //     setStartAnimate(true)
  //   }
  // }, [hovered])

  return (
    <>
      <Box
        {...boxProps}
        className={cx(classes.root, className)}
        onClick={() => setShowModal(true)}
        data-event-category={dataTracking?.dataEventCategory}
        data-event-action={dataTracking?.dataEventAction}
        data-event-label={dataTracking?.dataEventLabel}
      >
        <Box
          className={classes.item}
          // onMouseEnter={() => setHovered(true)}
          // onMouseLeave={() => setHovered(false)}
        >
          <Transition
            mounted={!toggle}
            transition={transition}
            duration={400}
            timingFunction="ease"
          >
            {(styles) => (
              <Box style={styles}>
                <Indicator
                  inline
                  processing
                  color="green"
                  size={8}
                  sx={{ marginTop: 3 }}
                >
                  <AirPopulation size={size === 'md' ? 32 : 24} />
                </Indicator>
              </Box>
            )}
          </Transition>
        </Box>
        <Box className={classes.item}>
          <Transition
            mounted={toggle}
            transition={transition}
            duration={400}
            timingFunction="ease"
          >
            {(styles) => (
              <Box style={styles}>
                <SimpleChart size={size} />
              </Box>
            )}
          </Transition>
        </Box>
      </Box>
      <ModalDetail opened={showModal} onClose={() => setShowModal(false)} />
    </>
  )
}
